<agpr-dialog-container
    [id]="id"
    heading="Briefings.addCoverage.automatic"
    (close)="cancel()"
    styleClass="agpr-automaticCoverageDialog"
>
    <agpr-scroll-panel>
        <div class="agpr-automaticCoverageDialog-content">
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                {{ 'Briefings.addCoverage.automatic.details' | localize }}
            </agpr-message>
            <agpr-monitoring-source-picker-without-facet-field
                [id]="id + '-sourcePickerField'"
                [value]="dataSource"
                [field]="sourceField"
                (changes)="sourceSelected($event)"
                [showHiddenOption]="true"
            ></agpr-monitoring-source-picker-without-facet-field>
            <agpr-text-field
                [id]="id + '-sectionName'"
                [value]="name"
                [field]="nameField"
                (changes)="nameChange($event)"
            ></agpr-text-field>
            <agpr-form-message
                *ngIf="nameTooLongError"
            >
                {{ 'Briefings.error.maxLengthReached' | localize: { length: name.length } }}
            </agpr-form-message>
            <agpr-form-message
                *ngIf="emptyNameError"
            >
                {{ 'Briefings.mentionList.form.sectionHeading.error.empty' | localize }}
            </agpr-form-message>
            <div class="agpr-automaticCoverageDialog-field">
                <div class="agpr-automaticCoverageDialog-contentLabel">
                    {{ 'Briefings.input.organizeSectionsBy' | localize }}
                </div>
                <agpr-dropdown
                    [options]="organizeOptions"
                    ariaLabel="Briefings.input.organizeSectionsBy"
                    [(ngModel)]="organizeByDropdown"
                    (ngModelChange)="onOrganizeByChanged($event.value)"
                ></agpr-dropdown>
            </div>
            <div class="agpr-automaticCoverageDialog-field">
                <span>
                    {{ 'Briefing.input.sortMentionsBy' | localize }}
                </span>
                <agpr-dropdown
                    [options]="sortOptions"
                    [(ngModel)]="sortByDropdown"
                    (ngModelChange)="onSortByChanged($event.value)"
                ></agpr-dropdown>
            </div>
            <agpr-number-input
                [id]="id + '-mentionCount'"
                [min]="minValue"
                [max]="maxValue"
                label="Briefings.dynamicMentionsList.form.numberOfMentions"
                tooltip="Briefings.dynamicMentionsList.form.numberOfMentionsTooltip"
                placeholder="Briefings.dynamicMentionsList.form.selectPageSize.short.placeholder"
                [integerOnly]="true"
                [(ngModel)]="maxNumberOfMentions"
                (ngModelChange)="maxMentionsInTopicChanged($event)"
            ></agpr-number-input>
            <agpr-form-message
                *ngIf="maxMentionsError"
            >
                {{ 'Briefings.dynamicMentionsList.form.numberOfMentionsErrorMessage' | localize }}
            </agpr-form-message>
        </div>
    </agpr-scroll-panel>
    <ng-template #footer>
        <div class="agpr-automaticCoverageDialog-footer">
            <ng-template #footerLeft>
            <agpr-button
                [id]="id + '-cancelButton'"
                [style]="buttonTypes.secondary"
                label="cancel"
                (click)="cancel()"
            ></agpr-button>
            </ng-template>
            <ng-template #footerRight>
            <agpr-button
                [id]="id + '-addCoverageButton'"
                label="add"
                [style]="buttonTypes.primary"
                (click)="addCoverage()"
            ></agpr-button>
            </ng-template>
        </div>
    </ng-template>

</agpr-dialog-container>
